import { Casa } from '@models/Casa';
import { doubleMask, moneyMask } from '@utils/masks';

const normalizeMoney = (value: unknown) => (value ? moneyMask.normalize(value as string) : 0);

export const buildFichaImovelSavePayload = (fichaImovel: Casa | null | undefined, values: Partial<Casa>) => {
  const formValues = {
    ...fichaImovel,
    ...values,
    aditivos: values.aditivos ?? fichaImovel?.aditivos ?? [],
    receitas: values.receitas ?? fichaImovel?.receitas ?? [],
  } as Casa;

  return {
    ...formValues,
    laudo: normalizeMoney(formValues.laudo),
    valorCompraVenda: normalizeMoney(formValues.valorCompraVenda),
    valorFinanciado: normalizeMoney(formValues.valorFinanciado),
    valorFGTS: normalizeMoney(formValues.valorFGTS),
    valorSubsidio: normalizeMoney(formValues.valorSubsidio),
    valorEntrada: normalizeMoney(formValues.valorEntrada),
    valorDesconto: normalizeMoney(formValues.valorDesconto),
    valorTotalLiquido: normalizeMoney(formValues.valorTotalLiquido),
    valorEntradaParcelada: normalizeMoney(formValues.valorEntradaParcelada),
    valorDoc: normalizeMoney(formValues.valorDoc),
    distribuido: normalizeMoney(formValues.distribuido),
    produtoAgencia: normalizeMoney(formValues.produtoAgencia),
    taxaAvista: normalizeMoney(formValues.taxaAvista),
    area: formValues.area ? doubleMask.normalize(formValues.area as string) : 0,
    valorm2: formValues.valorm2 ? moneyMask.normalize(formValues.valorm2) : 0,
    margem: normalizeMoney(formValues.margem),
    valorContratoObra: normalizeMoney(formValues.valorContratoObra),
    aditivos: formValues.aditivos.map((c) => ({ ...c, valor: moneyMask.normalize(c.valor as string) })),
    receitas: formValues.receitas.map((c) => ({ ...c, valor: moneyMask.normalize(c.valor as string) })),
  };
};

export const shouldReloadFichaAfterSave = (currentFichaID: string | number | undefined, savedFichaID: string | number) =>
  String(currentFichaID) === String(savedFichaID);
